import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { faEye, faRotate } from '@fortawesome/free-solid-svg-icons'
import { WjGridModule } from '@grapecity/wijmo.angular2.grid'
import { WjGridFilterModule } from '@grapecity/wijmo.angular2.grid.filter'

import { BaseComponent, Grid, ModalSize, VistaUpload } from '../../shared'
import { ActionToolbarCount } from '../../shared/reusable-components/action-toolbar-count/action-toolbar-count.component'
import { ActionToolbarSearchComponent } from '../../shared/reusable-components/action-toolbar-search/action-toolbar-search.component'
import { GridExportComponent } from '../../shared/reusable-components/grid-export/grid-export.component'
import { AutoSizeDirective } from '../../shared/utility/auto-size.directive'
import { VistaUploadDetailsComponent } from './vista-upload-details.component'

@Component({
    selector: 'app-vista-uploads-list',
    templateUrl: './vista-uploads-list.component.html',
    standalone: true,
    imports: [
        FormsModule,
        FaIconComponent,
        ActionToolbarCount,
        ActionToolbarSearchComponent,
        GridExportComponent,
        WjGridModule,
        AutoSizeDirective,
        WjGridFilterModule,
    ],
})
export class VistaUploadsListComponent extends BaseComponent {
    faEye = faEye
    faRotate = faRotate
    grid: Grid<VistaUpload>

    constructor() {
        super()
        this.grid = new Grid<VistaUpload>(this.services)
            .filterBy(item => [item.recordType, item.status, item.createdByName, item.fileName, item.batchId])
            .wrapColumnHeaders()
        this.refresh()
    }

    refresh() {
        this.cancelableRequest(
            '',
            true,
            this.services.data.load(true, true, this.services.data.vistaUploads.queryAllByAction('GetAll')).subscribe({
                next: result => {
                    this.grid.items = result[0]
                    this.initialLoadingComplete()
                },
                error: () => this.initialLoadingComplete(),
            }),
        )
    }

    openSelectedDetails() {
        const selected = this.grid.selectedItem as VistaUpload
        if (!selected) return
        const ref = this.services.modals.open(VistaUploadDetailsComponent, ModalSize.large)
        ;(ref.componentInstance as VistaUploadDetailsComponent).upload = selected
    }
}
